/**
 * Travelers Rest Events — Occasion hand-off for builder links
 * Loaded globally from layout/theme.liquid (deferred).
 *
 * WHY THIS EXISTS
 * The builder reads ?event=<slug> and prefills Step 1 from it
 * (assets/quote-calculator.js -> applyEventParam). But on 2026-08-18 the
 * corporate page was measured live and carried FIFTEEN links to the builder
 * with exactly ONE of them emitting the parameter — the hardcoded CTA in
 * snippets/event-feature-block.liquid, 2070px down the page. The hero CTA at
 * 98px and the first "Request a Corporate Quote" at 544px both linked to a
 * bare /pages/instant-quote, so the occasion was dropped by the links a
 * visitor actually reaches first.
 *
 * The other fourteen come from template JSON settings (cta_primary_url,
 * cta_url) and from global sections shared by every page. Editing those is
 * owner theme-editor work, it cannot reach the global sections per-page at
 * all, and template JSONs carry a standing "drift is often deliberate, do not
 * reconcile by pushing" hazard. So the hand-off is applied here instead, from
 * the one fact that is already canonical and SEO-locked: the page handle.
 *
 * ⛔ SLUGS MUST MATCH EVENT_PARAM_MAP in assets/quote-calculator.js. That map
 * is the whitelist and the owner of the slug -> label fact; this file only
 * decides which slug a page hands over. A slug that is not in that map is
 * ignored by the builder, so a mismatch degrades to today's behavior rather
 * than showing anything wrong.
 *
 * Failure mode by design: if this script does not run, every link behaves
 * exactly as it did before it existed.
 */
(function () {
  'use strict';

  // Page handle -> occasion slug. Handles are the Squarespace slugs preserved
  // at migration and must not be renamed (.claude/rules/content-sources.md).
  var HANDLE_TO_EVENT = {
    'corporate-event-venue-westchester': 'corporate',
    'mitzvah-event-venue-westchester':   'bar_bat_mitzvah',
    'wedding-event-venue-westchester':   'wedding',
    'bridal-shower-venue-westchester':   'bridal_shower',
    'baby-shower-venue-westchester':     'baby_shower',
    'birthday-party-venue-westchester':  'birthday',
    'celebrations-of-life-westchester':  'celebration_of_life'
  };

  function currentEventSlug() {
    var m = window.location.pathname.match(/\/pages\/([^/?#]+)/);
    if (!m) return null;
    var handle = m[1].toLowerCase();
    return Object.prototype.hasOwnProperty.call(HANDLE_TO_EVENT, handle)
      ? HANDLE_TO_EVENT[handle]
      : null;
  }

  function tagLinks(slug) {
    var links = document.querySelectorAll('a[href*="instant-quote"]');
    var tagged = 0;

    for (var i = 0; i < links.length; i++) {
      var raw = links[i].getAttribute('href');
      if (!raw) continue;

      // Resolve against the current page so relative, absolute and
      // shopify://-resolved hrefs are all handled the same way.
      var url;
      try { url = new URL(raw, window.location.origin); } catch (e) { continue; }

      if (url.origin !== window.location.origin) continue;   // never touch off-site links
      if (!/\/pages\/instant-quote\/?$/.test(url.pathname)) continue;
      if (url.searchParams.has('event')) continue;           // an explicit link wins

      url.searchParams.set('event', slug);
      // Keep the href relative so nothing depends on which domain served the page.
      links[i].setAttribute('href', url.pathname + url.search + url.hash);
      tagged++;
    }

    return tagged;
  }

  function init() {
    var slug = currentEventSlug();
    if (!slug) return;
    tagLinks(slug);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
